import { Text } from "@/design-system";
import { CheckCheck } from "lucide-react";
import { formatBRL, type HeroPayment } from "../constants/heroPayments";

type HeroPaymentRowProps = {
  payment: HeroPayment;
};

export function HeroPaymentRow({ payment }: HeroPaymentRowProps) {
  return (
    <div className="rounded-ds-lg border-ds-border bg-ds-paper-marketing flex items-center gap-3 border p-3 sm:gap-4 sm:p-4">
      <span className="bg-ds-brand-50 text-ds-brand-700 flex size-10 shrink-0 items-center justify-center rounded-full">
        <CheckCheck className="size-5" aria-hidden="true" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <Text as="span" weight="semibold" className="truncate">
          {payment.customer}
        </Text>
        <Text as="span" size="small" tone="subtle" className="truncate">
          {payment.detail}
        </Text>
      </div>
      <Text
        as="span"
        size="small"
        tone="success"
        weight="semibold"
        numeric
        className="shrink-0 whitespace-nowrap"
      >
        +{formatBRL(payment.amount)}
      </Text>
    </div>
  );
}
